/**
 * Shared empty-state card used by portal pages that have no data yet.
 *
 * - `variant="dashed"` for "coming soon" placeholders
 * - `variant="solid"` for "no data yet" pages (Invoices etc.)
 */
import { useTranslation } from "react-i18next";

const VARIANTS = {
  dashed:
    "rounded-3xl border-2 border-dashed border-slate-200 bg-white px-8 py-16 text-center",
  solid:
    "rounded-2xl border border-slate-200 bg-white px-8 py-20 text-center",
};

export const PortalEmptyState = ({
  icon: Icon,
  iconWeight = "light",
  variant = "dashed",
  titleKey,
  descKey,
  testId,
  badge,
}) => {
  const { t } = useTranslation();
  return (
    <div data-testid={testId} className={VARIANTS[variant]}>
      {Icon && variant === "dashed" && (
        <span className="mx-auto inline-flex h-14 w-14 items-center justify-center rounded-2xl adonis-gradient shadow-lg shadow-[#7B61FF]/25">
          <Icon size={24} weight={iconWeight} className="text-white" />
        </span>
      )}
      {Icon && variant === "solid" && (
        <Icon size={44} weight={iconWeight} className="mx-auto text-slate-300" />
      )}
      {badge}
      <h2 className="mt-6 font-heading text-base md:text-xl font-bold tracking-tight text-slate-900">
        {t(titleKey)}
      </h2>
      {descKey && (
        <p className="mt-3 text-sm text-slate-500 max-w-md mx-auto leading-relaxed">
          {t(descKey)}
        </p>
      )}
    </div>
  );
};

export default PortalEmptyState;
